import React from 'react'

import ProcessesViewModeWrapper from '../shared/ProcessesViewModeWrapper'
import PageContent from './PageContent'

const ProcessesDashboardPage = ({ id }) => {
  return (
    <ProcessesViewModeWrapper id={id}>
      <PageContent />
    </ProcessesViewModeWrapper>
  )
}

export default ProcessesDashboardPage
